import styled from "styled-components";

export const ProductContainerInfo = styled.div`

td{
    padding: 30px 5px !important;
}

p, strong{
    color: #333;
    font-size: 14px;
}

button{
    
}
`